import './edit-splash-screen.scss';

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormSplashScreen from "../form-splash-screen/form-splash-screen";
import { useEditSplashScreen } from "./edit-splash-screen.hook";

export function EditSplashScreen() {
  const {
    splashScreenData,
    isLoading,
    splashScreenError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditSplashScreen();

  const title =
    splashScreenData?.name ? <h1>{ splashScreenData?.name }</h1> : <h1>Edit Splash Screen</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormSplashScreen />
      </section>
    </div>
  );

  return (
    <div id="EditSplashScreen" className="splash-screen">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>
      
      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          { splashScreenError && !isLoading && displayError }
          {!isLoading ? mainContent : null}
         </FormProvider>
      </section>
    </div>
  );
}

export default EditSplashScreen;